import { useFormik } from "formik";
import React, { useCallback } from "react";
import { Trans } from "react-i18next";
import { useLocation } from "react-router-dom";
import {
  useGetPhonePrefixesQuery,
  useGetPosTerminalTypesQuery,
  useGetRegionsQuery,
} from "../../../api";
import { fetchCreateApplication } from "../../../api/application.api";
import { Input } from "../../../components/simple/Input";
import { LbSelect } from "../../../components/simple/LbSelect";
import { history } from "../../../helpers/history";
import i18n from "../../../i18n";
import { PosValidation } from "./validationSchema";
import { Column, Grid, Row } from "carbon-components-react";
import { Icon } from "../../../components/simple/Icon";
import LbCheckBox from "../../../components/simple/LbCheckBox";
import { Phone } from "../../../components/simple/Phone";
import { LbLoader } from "../../../components/simple/LbLoader";
import { LbToolTip } from "../../../components/simple/LbToolTip";

//

export const Index = () => {
  const { state } = useLocation();

  const posTerminalType =
    state && "posTerminalType" in state ? state.posTerminalType : "";
  const { data: options, isError, error, isLoading } = useGetRegionsQuery();
  const {
    data: terminalOptions,
    isLoading: isTerminalOptionLoading,
    isTerminalOptionError,
  } = useGetPosTerminalTypesQuery();

  const { data: phoneOptions, isLoading: isPhoneOptionsLoading } =
    useGetPhonePrefixesQuery();
  const formik = useFormik({
    initialValues: {
      productTypes: ["POS"],
      contactName: "",
      contactEmail: "",
      contactPhone: "",
      regionCode: null,
      companyCode: "",
      companyName: "",
      phonePrefixes: {
        code: "+995",
        country: "Georgia",
        exampleNumber: i18n.t("Common.Phone.Placeholder"),
        format: "(?:5(?:[14]4|5[0157-9]|68|7[0147-9]|9[1-35-9])|790)\\d{6}",
        id: "GE",
        label: "+995",
        value: "GE",
      },
      agree: false,
      enableCashback: true,
      posTerminalType: posTerminalType
        ? {
            label: i18n.t(`Application.Pos.${posTerminalType}`),
            value: posTerminalType,
          }
        : null,
    },
    validationSchema: PosValidation,
    onSubmit: async (values, methods) => {
      const { setSubmitting, resetForm } = methods;
      try {
        setSubmitting(true);
        await fetchCreateApplication({
          ...values,
          regionCode: values.regionCode && values.regionCode.value,
          posTerminalType:
            values.posTerminalType && values.posTerminalType.value,
          phonePrefixes: values.phonePrefixes && values.phonePrefixes.value,
        });
        resetForm();
        setSubmitting(false);
        history.push("/application/create/complete", {
          type: "success",
          productType: "POS",
        });
      } catch (error) {
        history.push("/application/create/complete", {
          type: "error",
          productType: "POS",
        });
      }
    },
  });

  const handleRegion = useCallback(
    async (val) => {
      await formik.setFieldValue("regionCode", val);
      await formik.setFieldTouched("regionCode", true);
    },
    [formik]
  );
  const handleType = useCallback(
    async (val) => {
      await formik.setFieldValue("posTerminalType", val);
      await formik.setFieldTouched("posTerminalType", true);
    },
    [formik]
  );
  const handlePrefix = useCallback(
    async (val) => {
      await formik.setFieldValue("phonePrefixes", val);
    },
    [formik]
  );
  const handelAgree = useCallback(
    async (e) => {
      // e.preventDefault();
      await formik.setFieldValue("agree", !formik.values.agree);
    },
    [formik]
  );
  const handelEnableCashBack = useCallback(
    async (val) => {
      await formik.setFieldValue("enableCashback", val);
    },
    [formik]
  );

  const styles = posTerminalType && {
    indicatorSeparator: () => {}, // removes the "stick"
    dropdownIndicator: (defaultStyles) => ({
      ...defaultStyles,
      "& svg": { display: "none" },
    }),
  };
  console.log(terminalOptions);
  return (
    <Grid>
      <Row>
        <Column lg={12}>
          <div className="w-768">
            {/* Pos ტერმინალი */}
            <div className=" text-center mb-64 mt-64">
              <h4 className="productive-heading-04 mb-24">
                <Trans i18nKey="Pos.Application.Title" />
              </h4>
              <p>
                <Trans i18nKey="Pos.Application.Description" />
              </p>
            </div>

            <div className="la-electronic-commerce">
              {/* <div className="la-electronic-commerce__row"> */}
              <Input
                label={i18n.t("Application.Pos.contactName")}
                name="contactName"
                value={formik.values.contactName}
                onChange={formik.handleChange("contactName")}
                onBlur={formik.handleBlur("contactName")}
                error={
                  "contactName" in formik.errors &&
                  "contactName" in formik.touched
                }
              />

              <Phone
                phoneOptions={phoneOptions}
                isLoading={isLoading}
                label={i18n.t("Application.Pos.contactPhone")}
                placeholder={
                  (formik.values.phonePrefixes &&
                    formik.values.phonePrefixes.exampleNumber) ||
                  i18n.t("Application.Pos.contactPhone.Placeholder")
                }
                name="contactPhone"
                value={formik.values.contactPhone}
                prefixValue={formik.values.phonePrefixes}
                onChange={formik.handleChange("contactPhone")}
                onPrefixChange={handlePrefix}
                onBlur={formik.handleBlur("contactPhone")}
                error={
                  "contactPhone" in formik.errors &&
                  "contactPhone" in formik.touched
                }
              />

              <Input
                label={i18n.t("Application.Pos.contactEmail")}
                name="contactEmail"
                value={formik.values.contactEmail}
                onChange={formik.handleChange("contactEmail")}
                onBlur={formik.handleBlur("contactEmail")}
                error={
                  "contactEmail" in formik.errors &&
                  "contactEmail" in formik.touched
                }
              />

              <LbSelect
                options={options}
                isLoading={isLoading}
                label={i18n.t("Application.Pos.regionCode")}
                value={formik.values.regionCode}
                onChange={handleRegion}
                onBlur={formik.handleBlur("regionCode")}
                error={
                  "regionCode" in formik.errors &&
                  "regionCode" in formik.touched
                }
                placeholder={i18n.t("Application.Pos.regionCode")}
              />
              {/* </div> */}
              {/* <div className="la-electronic-commerce__row"> */}

              {/* </div> */}
              {/* <div className="la-electronic-commerce__row"> */}
              {/* <Input
                label={i18n.t("Application.Pos.TerminalType")}
                name="posTerminalType"
                disabled
                value={
                  formik.values.posTerminalType &&
                  formik.values.posTerminalType.value
                }
              /> */}
              <div className="pos-terminal-type">
                <LbSelect
                  styles={styles}
                  disabled={!!posTerminalType}
                  options={
                    terminalOptions &&
                    terminalOptions.map((i) => ({
                      label: i18n.t(`Application.Pos.${i}`),
                      value: i,
                    }))
                  }
                  isLoading={isTerminalOptionLoading}
                  label={i18n.t("Application.Pos.TerminalType")}
                  value={formik.values.posTerminalType}
                  onChange={handleType}
                  onBlur={formik.handleBlur("posTerminalType")}
                  placeholder={i18n.t("Application.Pos.TerminalType")}
                />
              </div>

              <Input
                label={i18n.t("Application.Pos.companyName")}
                name="companyName"
                value={formik.values.companyName}
                onChange={formik.handleChange("companyName")}
                onBlur={formik.handleBlur("companyName")}
                error={
                  "companyName" in formik.errors &&
                  "companyName" in formik.touched
                }
              />
              <Input
                label={i18n.t("Application.Pos.companyCode")}
                name="companyCode"
                onChange={formik.handleChange("companyCode")}
                onBlur={formik.handleBlur("companyCode")}
                value={formik.values.companyCode}
                error={
                  "companyCode" in formik.errors &&
                  "companyCode" in formik.touched
                }
                placeholder={i18n.t("Application.Pos.companyCode.Placeholder")}
              />
              {/* </div> */}
              {/* <div className="la-electronic-commerce__row"> */}

              {/* </div> */}

              <div className="cashback-request">
                <div>
                  <p className="description">
                    {i18n.t("Application.Pos.EnableCashBack")}
                  </p>
                  <i className="icn" id="information1">
                    <Icon name="information" viewBox="0 0 20 20" />
                  </i>

                  <LbToolTip
                    forId="information1"
                    html={i18n.t("Pos.EnableCashback.Tooltip")}
                    place="right"
                  />
                </div>
                <div className="cashback-request--btns">
                  <label className="container mr-26">
                    {i18n.t("Common.Yes")}
                    <input
                      type="radio"
                      name="radio"
                      onClick={() => handelEnableCashBack(true)}
                      checked={formik.values.enableCashback}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="container">
                    {i18n.t("Common.No")}
                    <input
                      type="radio"
                      name="radio"
                      onClick={() => handelEnableCashBack(false)}
                      checked={!formik.values.enableCashback}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </div>

              <div className="agreement-terms mb-32">
                <p className="agreement-terms__details code-02">
                  {i18n.t("Application.Pos.AgreeRules")}
                </p>
                <LbCheckBox
                  id="agree"
                  i18nKey="Application.Pos.AcceptRules"
                  name="agree"
                  value={formik.values.agree}
                  checked={!!formik.values.agree}
                  onLabelClick={handelAgree}
                  onChange={handelAgree}
                  onBlur={formik.handleBlur("agree")}
                  error={"agree" in formik.errors && "agree" in formik.touched}
                />
              </div>

              <button
                className={`btn btn-black btn-request `}
                type="button"
                disabled={
                  !formik.dirty || formik.isSubmitting || !formik.isValid
                }
                onClick={formik.submitForm}
              >
                {formik.isSubmitting ? (
                  <LbLoader isLoading />
                ) : (
                  <Trans i18nKey="Common.Create" />
                )}
              </button>
            </div>
          </div>
        </Column>
      </Row>
    </Grid>
  );
};
